import { Box, styled } from "@mui/material";
import { useAuthStatus } from "helpers/useAuthStatus";
import { useMemo } from "react";
import { rolesPermissionsMatch } from "routes";
import { sidebarItems } from "./sidebarItems";
import { SideBarLinkItem } from "./SideBarLinkItem";

const PREFIX = "SideBar";

const classes = {
	root: `${PREFIX}-root`,
};

const StyledBox = styled(Box)(({ theme }) => ({
	[`&.${classes.root}`]: {
		backgroundColor: theme.palette.primary.main,
		width: "6.25rem",
		paddingTop: 10,
	},
}));

export const SideBar = (): JSX.Element => {
	const { role } = useAuthStatus();

	const userSidebarItems = useMemo(() => {
		const items: JSX.Element[] = [];

		for (const props of sidebarItems) {
			if (rolesPermissionsMatch(role, props.route.permissions)) {
				items.push(<SideBarLinkItem key={props.route.path} {...props} />);
			}
		}

		return items;
	}, [role]);

	return (
		<StyledBox
			display="flex"
			flexDirection="column"
			alignItems="center"
			className={classes.root}
			data-testid="sidebar"
		>
			{userSidebarItems}
		</StyledBox>
	);
};
